"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";

const SLIDES = [
  {
    gif: "/assets/gif/banner1.gif",
    title: "AI-Powered Course Finder for Your Perfect Match!",
    descLong: "Discover tailored study options for abroad education, matched to your interests and goals—effortlessly!",
    descShort: "Find study options abroad, tailored to your goals—effortlessly!",
  },
  {
    gif: "/assets/gif/banner2.gif",
    title: "AI-Powered Study Abroad Matches, Simplified",
    descLong: "Check your eligibility and explore top courses and universities designed to align with your aspirations—powered by AI",
    descShort: "Check eligibility and explore top AI-powered courses and universities.",
  },
  {
    gif: "/assets/gif/banner3.gif",
    title: "Smart Study Matches: Courses & Universities",
    descLong: "Let AI guide your abroad education with eligibility checks",
    descShort: "Let AI guide your abroad education with eligibility checks",
  },
];

const TryAiCourseFindBanner = ({
  className,
  radios,
}: {
  className?: string;
  radios?: boolean;
}) => {
  const [activeIndex, setActiveIndex] = useState(2);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % 3);
    }, 5000); // Change every 5 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const slide = SLIDES[activeIndex];

  return (
    <div
      className={`relative h-[270px] z-0 sm:h-[190px] pt-[10px] overflow-hidden ${className ? "" : "rounded-xl sm:rounded-2xl md:rounded-3xl"
        }`}
    >
      {/*
       * BANDWIDTH FIX: Previously all 3 banner GIF slides were rendered
       * simultaneously in the DOM with CSS opacity toggling. Even hidden
       * slides were fetched because the <Image> tags existed in the DOM.
       * Now only the ACTIVE slide is rendered, so only 1 GIF is downloaded
       * at a time (~5-6 MB instead of ~17 MB total on mount).
       */}
      <div
        className={`absolute top-0 w-full h-full bg-primary-gradient overflow-hidden ${!radios ? "!rounded-none" : "rounded-xl sm:rounded-2xl md:rounded-3xl"}`}
      >
        <div
          className={`sm:pr-4 xl:pr-14 2xl:pr-12 3xl:pr-[67px] overflow-hidden flex items-center justify-between flex-col lg:flex-row ${className ? className : ""
            }`}
        >
          <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-start gap-2 sm:gap-5 xl:gap-[33px] py-4">
            <Image
              key={slide.gif}
              className="hidden sm:block object-right object-cover max-w-[280px]"
              src={slide.gif}
              alt="banner"
              width={280}
              height={164}
              unoptimized
            />
            <Image
              key={`${slide.gif}-mobile`}
              className="sm:hidden max-w-[160px]"
              src={slide.gif}
              alt="banner"
              width={280}
              height={164}
              unoptimized
            />
            <div className="flex items-center sm:items-start flex-col gap-4 justify-center sm:justify-start px-2">
              <div className="max-w-[620px] 3xl:max-w-[767px]">
                <p className="ff_poppins font-semibold text-sm sm:text-base lg:text-xl 2xl:text-2xl xl:leading-[36px] text-white text-center sm:text-start">
                  {slide.title}
                </p>
                <p className="hidden sm:block font-normal ff_poppins text-xs sm:text-sm lg:text-base 2xl:text-xl xl:leading-[30px] text-white max-w-[550px] xl:max-w-[760px] text-center sm:text-start">
                  {slide.descLong}
                </p>
                <p className="sm:hidden font-normal ff_poppins text-xs sm:text-sm lg:text-base 2xl:text-xl xl:leading-[30px] text-white max-w-[767px] text-center sm:text-start">
                  {slide.descShort}
                </p>
              </div>
              <Link
                href={"/tools/course-finder?step=qualification"}
                className="py-[6px] sm:py-2 md:py-3 lg:py-3 xl:py-4 px-4 sm:px-5 md:px-6 lg:px-7 xl:px-8 rounded-xl ff_poppins text-primary bg-white font-semibold text-sm sm:text-base md:text-lg xl:text-xl leading-[30px] text-nowrap lg:hidden"
              >
                Try Now
              </Link>
            </div>
          </div>
          <Link
            href={"/tools/course-finder?step=qualification"}
            className="py-4 px-8 hidden lg:block rounded-xl ff_poppins text-primary bg-white font-semibold text-xl leading-[30px] text-nowrap"
          >
            Try Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TryAiCourseFindBanner;
